import { useCallback } from 'react';
import { useMsal } from '@azure/msal-react';

export const useLogout = () => {
  const { instance } = useMsal();

  const logout = useCallback(() => {
    instance.logout();
  }, [instance]);

  return logout;
}